
import { i18nText } from '@/locales';
import {Component} from "vue-property-decorator";
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {required} from "vuelidate/lib/validators";
import { ISalons } from "@/entity/salons/salons.types";
import { VisitGeneralRequestType } from "./visitGeneral.types";
import { IVisitsListItem } from "@/entity/visits/visit.types";
import { IConsumables, IConsumablesListItem } from "@/entity/consumables/consumables.types";

@Component
export default class VisitGeneralForm extends Form{
    id = 0;
    @Validate(required, i18nText("Введите статус"))
    status_id = 0;
    salon_id = 0;
    
    @Validate(required, i18nText("Введите дату"))
    visit_date: string | null = null;
    visit_date_time_start: string | null  = null;
    visit_date_time_end: string | null = null;
    visit_duration: string | null  = null;

    comment: string | null  = null;
    color: string | null  = null;
    category: string | null  = null;
    note: string | null  = null;
    client_id: number | null  = null;
    another_client: boolean | number  = 0;

    clients_info: any[] | null = null;
    client_name: string | null = null;
    client_email: string | null = null;
    client_phone: string | null = null;
    client_debt: string | null = null;
    client_status: number | null = null;
    client_count_visits: number | null = null;
    client_sold: number | null = null;
    client_paid: number | null = null;
    client_source: string | string = ' ';

    service_list: any[] | null = null

    service_data: any[] | null = null;
    consumables_data: any[] | null = null;

    service_visits_group: any [] | null = null;
    products: any[] | null = [];
    certificates: any[] | null = null;
    memberships: any[] | null = null;
    clienta_change_date: any[] | null = null;

    cosmetologists_id: number | null  = null;
    notification_id: number | null  = null;
    history_changes_id: number | null  = null;
    payment_id: number | null  = null;
    total_amount: number | null = null;
    salons: ISalons | null = null;

    visit_general_flag = true;

    visit_update_flag = false;

    value_for_forms: any[] = [{}];

    total_count: number = 0;
    total_price: number = 0;

    client_last_visit_date: string | null = null;
    created_date: string | null = null;

    getFormData() : VisitGeneralRequestType {
        return {
            id: this.id,
            status_id: this.status_id,
            salon_id: this.salon_id,

            visit_date: this.visit_date,
            visit_date_time_start: this.visit_date_time_start,
            visit_date_time_end: this.visit_date_time_end,
            visit_duration: this.visit_duration,

            comment: this.comment,
            color: this.color,
            category: this.category,
            note:  this.note,
            client_id: this.client_id,
            another_client: this.another_client,

            
            client_phone: this.client_phone,
            client_email: this.client_email,
            client_source: this.client_source,
            
            service_data: this.service_data,
            service_visits_group: this.service_visits_group,
            consumables_data: this.consumables_data,
            products: this.products,
            certificates: this.certificates,
            memberships: this.memberships,
            clienta_change_date: this.clienta_change_date,

            cosmetologists_id: this.cosmetologists_id,
            notification_id: this.notification_id,
            history_changes_id: this.history_changes_id,
            payment_id: this.payment_id,
            total_amount: this.total_amount,
            
            client_last_visit_date: this.client_last_visit_date,
            created_date: this.created_date,
        }
    }

    setConsumablesData(consumables: any[]): void{
        this.consumables_data = [];
        for (let i = 0; i < consumables.length; i++) {
            this.consumables_data?.push({
                id: consumables[i].id,
                product_id: consumables[i].product_id,
                product_name: consumables[i].product_name,
                product_price: consumables[i].product_price,
                quantity: consumables[i].quantity,
                service_id: consumables[i].service_id,
                store_id: consumables[i].store_id,
                store_name: consumables[i].store_name,
            });
        }
    }

    setTimeToUpdate(visit_date : string, visit_date_time_start : string,  visit_date_time_end : string, visit_duration : string){

        console.log('in form general');

        console.log(visit_date);
        console.log(visit_date_time_start);
        console.log(visit_duration);

        this.visit_date = visit_date;
        this.visit_date_time_start = visit_date_time_start;
        this.visit_date_time_end = visit_date_time_end;
        this.visit_duration = visit_duration;

        this.visit_update_flag = true;
        console.log('after save');
        console.log(this.visit_date);
        console.log(this.visit_date_time_start);
        console.log(this.visit_duration);

    }

    setFormData(visit: any[]): void {
        for (let i = 0; i < visit.length; i++) {
            
            this.id        = visit[i].id;
            this.status_id = visit[i].status_id;
            this.salon_id = visit[i].salon_id;
            this.visit_date = visit[i].visit_dt;
            this.visit_date_time_start = visit[i].visit_dt_start;
            this.visit_date_time_end = visit[i].visit_dt_end;
            this.visit_duration = visit[i].visit_duration;
            this.comment = visit[i].comment;
            this.color = visit[i].color;
            this.category = visit[i].category;
            this.note = visit[i].note;
            this.client_id = visit[i].client_id;
            this.another_client = visit[i].another_client;
            this.cosmetologists_id = visit[i].cosmetologists_id;
            this.certificates = visit[i].certificates;
            this.memberships = visit[i].memberships;
            this.clients_info = visit[i].clientVisitInfo;
            this.client_last_visit_date = visit[i].clientVisitInfo.visit_last_date;
            this.created_date = visit[i].created_date;
            this.client_source = visit[i].client.source;

            if(visit[i].services)
                this.service_list = visit[i].services;

            if(visit[i].service_visits_groups.data)
            {
                this.service_data = [];
                this.service_visits_group = visit[i].service_visits_groups;
                for (let j = 0; j < visit[i].service_visits_groups.data.length; j++) {

                    this.service_data?.push({
                        id: visit[i].service_visits_groups.data[j].id,
                        service_id: visit[i].service_visits_groups.data[j].service_id,
                        quantity: visit[i].service_visits_groups.data[j].quantity,
                    });
                }
                console.log('this push');
                console.log(this.service_data);
            }

        
            if(visit[i].status)
                this.client_status = visit[i].status.id;
            
            if(visit[i].client){
                this.client_name = visit[i].client.name;
                this.client_email = visit[i].client.email;
                this.client_phone = visit[i].client.phone;
                this.client_debt = visit[i].client.debt ?? 0;
                this.client_sold = visit[i].client.sold ?? 0;
                this.client_paid = visit[i].client.paid != null && visit[i].client.paid
                != undefined ? visit[i].client.paid : 0;
                console.log('paid');
                console.log(this.client_paid);
                this.client_count_visits = visit[i].clientVisitInfo.count_visits ?? 0;

            } 
            
            // this.form.consumables_data?.push({
            //     id: this.consumables.data[i].id,
            //     product_id: this.consumables.data[i].product_id,
            //     product_name: this.consumables.data[i].product_name,
            //     product_price: this.consumables.data[i].product_price,
            //     quantity: this.consumables.data[i].quantity,
            //     service_id: this.consumables.data[i].service_id,
            //     store_id: this.consumables.data[i].store_id,
            //     store_name: this.consumables.data[i].store_name,
            // });

        }   
    }
}
